"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a, _b;
exports.__esModule = true;
exports.defaultDataState = void 0;
var MogamboConstants_1 = require("@src/constants/MogamboConstants");
var types = __importStar(require("./actionTypes"));
exports.defaultDataState = {
    active: undefined,
    key_name: '',
    values: (_a = {},
        _a[MogamboConstants_1.DEFAULT_LANGUAGE] = (_b = {},
            _b[MogamboConstants_1.DEFAULT_LANGUAGE] = '',
            _b),
        _a),
};
var initialState = {
    isAddModalActive: false,
    constantData: __assign({}, exports.defaultDataState),
    constantDataCopy: __assign({}, exports.defaultDataState),
    currentLanguage: MogamboConstants_1.DEFAULT_LANGUAGE,
    currentHybridLanguage: MogamboConstants_1.DEFAULT_LANGUAGE,
    addMode: true,
    isDeleteModalActive: false,
    errorLanguages: [],
    editedLanguages: [],
};
function reduce(state, action) {
    var _a;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types.SET_ADD_MODAL_ACTIVE:
            return __assign(__assign({}, state), { isAddModalActive: action.data.flag, addMode: ((_a = action.data) === null || _a === void 0 ? void 0 : _a.addMode) || false, errorLanguages: [] });
        case types.SET_CURRENT_LANGUAGE:
            return __assign(__assign({}, state), { currentLanguage: action.data.code });
        case types.SET_CURRENT_HYBRID_LANGUAGE:
            return __assign(__assign({}, state), { currentHybridLanguage: action.data.code });
        case types.SET_GLOBAL_CONSTANT_DATA:
            return __assign(__assign({}, state), { constantData: __assign({}, action.data.constantData), constantDataCopy: __assign({}, action.data.constantData) });
        case types.UPDATE_GLOBAL_CONSTANT_DATA:
            return __assign(__assign({}, state), { constantData: __assign({}, action.data.updatedData), editedLanguages: action.data.updatedEditedLanguages });
        case types.RESET_GLOBAL_CONSTANT_DATA:
            return __assign(__assign({}, state), { constantDataCopy: state.constantDataCopy, currentHybridLanguage: MogamboConstants_1.DEFAULT_LANGUAGE, currentLanguage: MogamboConstants_1.DEFAULT_LANGUAGE, addMode: true, errorLanguages: [], editedLanguages: [] });
        case types.SET_DELETE_MODAL_ACTIVE:
            return __assign(__assign({}, state), { isDeleteModalActive: action.data.flag });
        case types.SET_ERROR_LANGUAGES:
            return __assign(__assign({}, state), { errorLanguages: action.data.list });
        default:
            return state;
    }
}
exports["default"] = reduce;
